module.exports = __webpack_public_path__ + "static/media/rover-curiosity.fbf08c5e.svg";